import { createSlice } from '@reduxjs/toolkit';
import { CategoriesState } from './categoryModels';
import { getAllCategories, getProductsByCategory } from './categoryThunks';

const initialState: CategoriesState = {
  categories: [],
  currentCategory: null,
  categoryProducts: [],
  totalPages: 0,
  currentPage: 1,
  totalCategories: 0,
  totalProducts: 0,
  loading: false,
  error: null,
  status: 'idle',
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    clearCategoryProducts: (state) => {
      state.categoryProducts = [];
      state.currentCategory = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all categories
      .addCase(getAllCategories.pending, (state) => {
        state.loading = true;
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.categories = action.payload.categories;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
        state.totalCategories = action.payload.totalCategories;
      })
      .addCase(getAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch categories';
      })
      // Get products by category
      .addCase(getProductsByCategory.pending, (state) => {
        state.loading = true;
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getProductsByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.currentCategory = action.payload.category;
        state.categoryProducts = action.payload.products;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
        state.totalProducts = action.payload.totalProducts;
      })
      .addCase(getProductsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch products by category';
      });
  },
});

export const { clearCategoryProducts, clearError } = categoriesSlice.actions;
export default categoriesSlice.reducer;

